// src/components/ads-admin/LockedSection.jsx
import React from "react";

export default function LockedSection({ locked, reason, children }) {
  return (
    <div style={{ position: "relative" }}>
      <div style={{ opacity: locked ? 0.5 : 1, pointerEvents: locked ? "none" : "auto" }}>{children}</div>

      {locked && (
        <div
          aria-hidden="true"
          style={{
            position: "absolute",
            inset: 0,
            borderRadius: 16,
            background: "linear-gradient(to bottom, rgba(255,255,255,0.6), rgba(255,255,255,0.85))",
            border: "1px dashed rgba(15,23,42,0.18)",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            padding: 14,
            textAlign: "center",
          }}
        >
          <div style={{ maxWidth: 520, display: "grid", gap: 8 }}>
            <div style={{ fontWeight: 950, color: "#0f172a" }}>🔒 Locked</div>
            <div style={{ fontSize: 12, fontWeight: 800, color: "#334155", lineHeight: 1.45 }}>
              {reason || "Complete the previous step(s) first."}
            </div>
          </div>
        </div>
      )}
    </div>
  );
}